import { directive as vClickOutside } from 'vue-clickaway';
import accessControl from '@/directives/access-control';

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(Vue) {
    Vue.directive('click-outside', vClickOutside);
    Vue.directive('access-control', accessControl);
  }
};

export default GlobalDirectives;
